"use client";

import { m } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

const TESTIMONIALS = [
  {
    name: "Shiloh",
    role: "Woodturner, SNG Woodwork",
    project: "sng-woodwork",
    quote:
      "Micah built the whole site — checkout, inventory, those certificate things with the QR codes. I sell bowls online now. Before this I was doing everything through Instagram DMs. The certificate of provenance thing? That's gotten me repeat buyers who want to know exactly which tree their bowl came from.",
  },
  {
    name: "Shawn",
    role: "Owner, O'Connor Land Works",
    project: "oconnor-land-works",
    quote:
      "I needed a site that didn't look like every other landscaping company. Micah built it in a week. The quote request form actually works — I get leads straight to my phone. Already landed two jobs from it and it's been live a month.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="relative px-4 py-24">
      <div className="section-divider mx-auto mb-20 max-w-xl" />

      <div className="mx-auto max-w-6xl">
        <SectionHeader
          index="03"
          code="feedback"
          align="left"
          title={<>What people <span className="gradient-text">say</span></>}
          blurb="I don’t do marketing speak well, so I’ll let them talk."
        />

        <div className="grid gap-6 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <AnimatedSection key={t.project} delay={i * 0.1}>
              <m.div
                whileHover={{ y: -4 }}
                className="glass-card group flex h-full flex-col rounded-2xl p-8 ring-1 ring-white/[0.06] transition-all hover:bg-white/[0.03]"
              >
                {/* Quote mark */}
                <div className="mb-4 text-4xl font-serif text-emerald-500/20 leading-none">
                  &ldquo;
                </div>

                <p className="flex-1 text-base leading-relaxed text-white/80">
                  {t.quote}
                </p>

                <div className="mt-6 flex items-center gap-3 border-t border-white/[0.06] pt-5">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500/10 text-sm font-bold text-emerald-400 ring-1 ring-emerald-500/20">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{t.name}</p>
                    <p className="text-xs text-[#94A3B8]">{t.role}</p>
                  </div>
                </div>
              </m.div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
